import React, { useState } from "react";

import fallback_img from "../img/fallback_img.jpg"

import loading_img from "../img/loadingImg.jpg"
import { useDispatch } from "react-redux";
import { ChartNoAxesGantt, EllipsisVertical, ImagePlus, Pencil } from "lucide-react";
const ImageWithFallbackLogo = ({ src ,widthOuter,fireOpenEdit,iconSize,setOpenFullImg}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
  
     const dispatch = useDispatch();  
   const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        }
          
     
  return (<div>
    <div  className="hoverFBackImgEdit"
      style={{ marginTop: "0px",marginBottom: "0px",
        aspectRatio: "1 / 1",
        width:"150px",height:"42px",
        position: "relative",
      }}

      onClick={()=>{fireOpenEdit() ;setOpenFullImg()}}
    >
      <div  className="hoverFBackImgEditInner"
          style={{
            borderRadius: "10px",
          position: "absolute",
          top: 0,
          left: 0,
          width: "90%",
          height: "90%",
          objectFit: "cover",
          marginTop: "0px",
            zIndex:"9999",
            display: "flex",
            alignItems: "center",border:"0px solid #f1f1f1",
            justifyContent: "center",
            fontSize: "12px",background:"rgba(144, 202, 249,0.8)",
            color: "#999",
            borderRadius: "0%",
          }}
           onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
        >
          <ImagePlus  size={iconSize} color="#ffffff"/>
        </div>

      {!isLoaded && !hasError && (
        <img
        src={loading_img}
        alt=""
      style={{
          borderRadius: "0%",
          position: "absolute",
          top: 0,
          left: 0,
          width: "90%",
          height: "90%",
          objectFit: "cover",
          marginTop: "0px",border:"0px solid #f1f1f1",
      
          }}
      />
      )}
      
      <img
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
        style={{
          borderRadius: "0%",
          position: "absolute",
          top: 0,
          left: 0,
          width: "90%",
          height: "90%",
          objectFit: "cover",
          marginTop: "0px",border:"0px solid #f1f1f1",
        //   display: isLoaded && !hasError ? "block" : "none",
        }}
      />
    </div>
    
    </div>
  );
};


export default ImageWithFallbackLogo;